

//----- ip -----
// const dominio = "http://192.168.0.79:5000";

//----- Local ------
// const dominio = "http://192.168.0.79:7000";

//----- Publica ------
 const dominio = "http://190.56.9.222:7000";



const rutas = {


//----------- NUEVOS -----------------

nombre: `${dominio}/ruta`,
get_list_autorizaciones: `${dominio}/get_list_autorizaciones`,
};

module.exports = {
  dominio,
  rutas,
};





